// extracted by mini-css-extract-plugin
module.exports = {"ActivityRules":"ActivityRules_ActivityRules__YUvzo"};